import { Grid, Typography, useTheme } from "@mui/material";
import conversationsSvg from "conversations.svg";
import { observer } from "mobx-react";
import React from "react";
import { useStore } from "utils/useStore";
import { ClassifierBuilderV2Store } from "../../Stores/ClassifierBuilderV2Store";
import ClassifierBuilderV2ResultsList from "./ClassifierBuilderV2ResultsList";
import AcxLoadingIndicator from "components/UI/AcxLoadingIndicator";

type Props = {};

const ClassifierBuilderV2ResultsListWrapper: React.FC<Props> = observer(() => {
    const store = useStore(ClassifierBuilderV2Store);
    const theme = useTheme();

    const noResultsView = (
        <Grid
            container
            item
            justifyContent="center"
            alignItems="center"
            direction="column"
            sx={{ width: "100%", height: "100%" }}
        >
            <Grid item sx={{ marginBottom: theme.spacing(1) }}>
                <img
                    alt="conversations icon"
                    src={conversationsSvg}
                    style={{ width: "300px" }}
                />
            </Grid>
            <Grid item sx={{ marginBottom: theme.spacing(1) }}>
                <Typography
                    variant="h1"
                    sx={{ fontSize: "32px" }}
                >
                    No Search Results Yet
                </Typography>
            </Grid>
            <Grid item>
                <Typography
                    variant="h1"
                    sx={{ fontSize: "18px", color: "grey" }}
                >
                    Try adjusting your search terms to find what you're looking
                    for.
                </Typography>
            </Grid>
        </Grid>
    );

    return (
        <Grid
            container
            direction="column"
            justifyContent="center"
            alignContent="center"
        >
            <Grid container item xs={12} direction="column" alignItems="center">
                {store.resultsLoading ? (
                    <AcxLoadingIndicator
                        size={50}
                        color="secondary"
                        alternate="PuffLoader"
                    />
                ) : store?.estimatedTotalResCount ? (
                    <ClassifierBuilderV2ResultsList />
                ) : (
                    noResultsView
                )}
            </Grid>
        </Grid>
    );
});

export default ClassifierBuilderV2ResultsListWrapper;
